import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2, FileDown, Eye } from "lucide-react";

export default function Reconciliation() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [detail, setDetail] = useState(null);

  const load = async () => {
    setBusy(true);
    const { data } = await api.get("/api/admin/reconciliation");
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, []);

  const exportCsv = (id) => {
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/admin/reconciliation/${id}/export?fmt=csv`, "_blank");
  };

  return (
    <div className="space-y-6" data-testid="reconciliation-page">
      <div className="text-[var(--text-2)] text-sm">Compare Provider vs Aggregator vs Operator totals. Detect missing or duplicate transactions.</div>

      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto">
          <table className="aggr-table">
            <thead><tr>
              <th>Run date</th><th>Operator</th><th>Provider</th><th>Aggregator</th><th>Operator total</th>
              <th>Missing bets</th><th>Missing wins</th><th>Mismatch</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              {busy && <tr><td colSpan={10} className="text-center py-6"><Loader2 className="inline animate-spin" size={14}/></td></tr>}
              {!busy && items.map(r => (
                <tr key={r.id}>
                  <td className="font-mono text-xs">{r.run_date}</td>
                  <td className="font-mono text-xs">{r.operator_id}</td>
                  <td className="font-mono">{r.total_provider}</td>
                  <td className="font-mono">{r.total_aggregator}</td>
                  <td className="font-mono">{r.total_operator}</td>
                  <td className="font-mono text-[var(--warning)]">{r.missing_bets}</td>
                  <td className="font-mono text-[var(--warning)]">{r.missing_wins}</td>
                  <td className="font-mono text-[var(--error)]">{r.amount_mismatch}</td>
                  <td><StatusBadge status={r.status}/></td>
                  <td className="text-right">
                    <div className="flex justify-end gap-1">
                      <button onClick={() => setDetail(r)} className="p-2 hover:bg-[var(--surface-2)] rounded" title="View" data-testid={`view-recon-${r.id}`}><Eye size={13}/></button>
                      <button onClick={() => exportCsv(r.id)} className="p-2 hover:bg-[var(--surface-2)] rounded" title="Export CSV" data-testid={`export-recon-${r.id}`}><FileDown size={13}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {detail && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div className="card-surface w-full max-w-2xl p-6" onClick={(e) => e.stopPropagation()} data-testid="recon-detail">
            <div className="text-lg font-semibold mb-4">Reconciliation · {detail.run_date}</div>
            <pre className="font-mono text-xs bg-[var(--bg)] border border-[var(--border)] rounded p-3 overflow-x-auto max-h-[60vh]">
{JSON.stringify(detail, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
}
